<div class="navigation">
  <h2 mat-dialog-title>
    @if (order.bundleId) {
      {{ order.bundleName }}
    } @else {
      My Bundle
    }
  </h2>
  <div class="back-icon">
    <button mat-icon-button (click)="goBack()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-dialog-content
  class="content"
  [class.mobile-view-active]="isMobileView"
  [formGroup]="bundleForm"
>
  <div class="container">
    <div class="left-column">
      <div class="add-product-list-wrapper">
        @if (bundleSettings && bundleSettings.products.length > 0) {
          <lib-bundle-product-list
            [products]="bundleSettings.products"
            [orderVerboseName]="orderVerboseName"
            (increment)="onIncrement($event)"
            (decrement)="onDecrement($event)"
            [selectedProducts]="selectedProducts"
            [bundleSize]="selectedBundle"
          />

          <mat-divider vertical />
        }
      </div>
    </div>
    <div class="right-column">
      <div class="right-contatiner">
        @if (selectedBundle > 0) {
          <lib-bundle-product-list-item-selected-list
            [selectedProducts]="selectedProducts"
            [bundleSize]="selectedBundle"
            [rewardsSettings]="rewardsSettings"
            (remove)="onRemove($event)"
          />
        }

        <!-- <div class="flex-container mt-4 bundle-size">
          @for (reward of rewardsSettings; track reward.id) {
            <lib-bundle-size
              [bundleSize]="reward.itemCountToActivateReward"
              [bundleSizeText]="
                reward.itemCountToActivateReward + ' Item Bundle'
              "
              [freeShippingText]="
                'Up to ' +
                reward.rewardDiscountPercentage +
                '% Off' +
                (reward.rewardFixedShippingCost !== undefined &&
                reward.rewardFixedShippingCost !== null &&
                reward.rewardFixedShippingCost > 0
                  ? ' + Free Shipping'
                  : '')
              "
              [isSelected]="selectedBundle === reward.itemCountToActivateReward"
              (click)="selectBundle(reward.itemCountToActivateReward)"
              (keydown)="selectBundle(reward.itemCountToActivateReward)"
            />
          }
        </div> -->
        @if (
          bundleSettings &&
          bundleSettings.frequencyOptions &&
          bundleSettings.frequencyOptions.length > 0
        ) {
          <div class="frequency-select-container mt-4">
            <label class="frequency-label">Shipping Frequency</label>
            <mat-form-field appearance="outline" class="frequency-select">
              <mat-select formControlName="selectedFrequency">
                @for (
                  option of bundleSettings.frequencyOptions;
                  track option.id
                ) {
                  <mat-option [value]="option">
                    {{ formatFrequencyOption(option) }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
        <div class="flex-container mt-2 h-30">
          @if (
            isFreeShipping ||
            (totalSavingsPercentage && totalSavingsPercentage > 0)
          ) {
            <lib-bar-tag
              [className]="'autoship-save'"
              [icon]="'sell'"
              actionName="-{{
                totalSavings | number: '1.0-2' | currency: 'USD' : 'symbol'
              }}"
              [isActionClickable]="false"
              text="{{
                siteSettingsService.siteSettings.localization?.autoshipAndSave
                  ? siteSettingsService.siteSettings.localization
                      ?.autoshipAndSave
                  : 'Autoship & Save'
              }} {{ totalSavingsPercentage | number: '1.0-2' }}%"
            />
          }
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="buttons" [class.mobile-layout]="isMobileView">
  <md-outlined-button (click)="goBack()" class="mr-2"
    >Cancel</md-outlined-button
  >
  <md-filled-button color="primary" (click)="onSubmit()"
    >Update Bundle</md-filled-button
  >
</mat-dialog-actions>
